import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyBf4BndRMicxE9J4tIdvBfXZD7IRRR1tYo',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'jobseeqr.co',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'jobseeqr',
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || 'https://jobseeqr.firebaseio.com',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'jobseeqr.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '435586021357',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:435586021357:web:5a192f0a7fd6100a71d9e4'
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);
const storage = getStorage(app);

export { auth, database, storage };
export default app;
